import { MetricTypeEnum } from "@/model/data/enums/MetricTypeEnum";
import { Command, HttpVerbType, API_PREFIX, API_VERSION } from "../Command";
import { GetInstallationNetworkMetricsResData } from "./GetInstallationNetworkMetricsResData";

const ENDPOINT = "/network_metrics/installation/type";

export class GetInstallationNetworkMetricsCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "get";
    params: GetInstallationNetworkMetricsReqData;

    constructor(installationName: string, startDate: Date, endDate: Date, metricType: MetricTypeEnum) {
        super();
        this.params = new GetInstallationNetworkMetricsReqData(installationName, startDate, endDate, metricType);
    }

    public async execute(): Promise<GetInstallationNetworkMetricsResData> {
        var res = await this.executeCommand(null, null, this.params);
        return new GetInstallationNetworkMetricsResData(res);
    }
}

export class GetInstallationNetworkMetricsReqData {
    installationName: string;
    startDate: Date;
    endDate: Date;
    metricType: MetricTypeEnum;

    constructor(installationName: string, startDate: Date, endDate: Date, metricType: MetricTypeEnum) {
        this.installationName = installationName;
        this.startDate = startDate;
        this.endDate = endDate;
        this.metricType = metricType;
    }
}
